module.exports = __webpack_public_path__ + "img/PlacesParts.00fdc2a8.svg";